import { CrewMember, FrequentPassageRequest } from '@legacy-types';

import { useData } from '@shared/api/hooks/useData';
import { FrequentPassageRequestDataTable } from '@shared/frequent-passage-requests/components/FrequentPassageRequestDataTable';
import { getFrequentPassageRequests } from '@shared/frequent-passage-requests/endpoints/getFrequentPassageRequest';
import { Portlet } from '@shared/ui/components/Portlet';

type ShowUserRegistrationFrequentPassageRequestsProps = {
  crewMember: CrewMember;
};

export function ShowUserRegistrationFrequentPassageRequests({
  crewMember,
}: ShowUserRegistrationFrequentPassageRequestsProps) {
  const frequentPassageRequests = useData<FrequentPassageRequest>({
    get: getFrequentPassageRequests,
    defaults: { sort: '-updated_at' },
    query: { filter: { crew_member_id: crewMember.id }, page: { size: 100 } },
    history: false,
  });

  return (
    <Portlet title="Frequent Passage Requests">
      <FrequentPassageRequestDataTable
        frequentPassageRequests={frequentPassageRequests}
        columns={{ registration: false }}
        avoidPagination
        withoutFilters
      />
    </Portlet>
  );
}
